import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e5951da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "position-relative w-100 h-100"
}
const _hoisted_2 = {
  key: 0,
  class: "toolBox space-x-4px"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_zoomer = _resolveComponent("v-zoomer")!

  return (!_ctx.previewUrl)
    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
        key: 0,
        color: "#fff ",
        indeterminate: "",
        width: "5",
        size: "40"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.toolBar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_btn, {
                icon: 'bi bi-plus-lg',
                size: "x-small",
                class: "text-white bgPurple",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.zoomerRef?.zoomIn()))
              }),
              _createVNode(_component_v_btn, {
                icon: 'bi bi-dash-lg',
                size: "x-small",
                class: "text-white bgMint",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.zoomerRef?.zoomOut()))
              }),
              _createVNode(_component_v_btn, {
                text: "Reset",
                rounded: "xl",
                flat: "",
                border: "",
                style: {"border-color":"#dadbe6"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.zoomerRef?.reset()))
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_zoomer, {
          ref: "zoomerRef",
          class: "w-100 h-100",
          "max-scale": 10,
          "zooming-elastic": false,
          "aspect-ratio": 1,
          "limit-translation": false
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.previewUrl,
              class: "image"
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }, 512)
      ]))
}